export default __webpack_public_path__ + "static/1-13dc8c2c6ecd11f26b67355eafc2811d.png";